import React from 'react'
import SideBarLayout from "../../../layout/side-bar-layout"
import TabsWrappedLabel from "../../../components/tabs/tabs-component"
import {Paper} from "@mui/material"
import TabelaDownloadArquivo from "./components/tabela-download-arquivo"
import {moduloDois, moduloUm} from "./modulos"


const TITLE_TREINAMENTO_MERCADO_PAGO_TITLE_PAGE = "Mercado Pago - Treinamento"

const TreinamentoMercadoPagoPage = () => {

    return <SideBarLayout
        title={TITLE_TREINAMENTO_MERCADO_PAGO_TITLE_PAGE}
        header
        loading={false}
        headerImage="/background/treinamento_header.jpg"
        headerPosition={"80%, 57%"}
        headerTitle={TITLE_TREINAMENTO_MERCADO_PAGO_TITLE_PAGE}
    >
        <Paper
            sx={{
                mt: -2,
            }}
        >
            <TabsWrappedLabel
                tabs={[
                    {
                        value: "modulo1",
                        label: "MÓDULO 1",
                        content: <TabelaDownloadArquivo rows={moduloUm} />,
                    },
                    {
                        value: "modulo2",
                        label: "MÓDULO 2",
                        content: <TabelaDownloadArquivo rows={moduloDois} />,
                    },
                ]}
            />
        </Paper>

        <br/>

    </SideBarLayout>
}

export default TreinamentoMercadoPagoPage